type PhysicalProductCallToActionsProps = {
  productUrl: string
  purchased?: boolean
  productHotLink: string
}

export const getPhysicalProductActions = ({
  purchased,
  productUrl,
  productHotLink
}: PhysicalProductCallToActionsProps) => {
  if (purchased) {
    return [
      {
        to: productHotLink,
        label: `home.card_cta.purchase`,
        type: 'success'
      },
      {
        to: productUrl,
        label: 'home.card_cta.order_details',
        type: 'primary'
      }
    ]
  }

  return [
    {
      to: productUrl,
      label: `home.card_cta.purchase`,
      type: 'success'
    }
  ]
}
